module.exports = __webpack_public_path__ + "img/hover-wx.2104b6ad.png";